import { Collapse, Grid } from '@mui/material';
import React from 'react';
import { MemberCampaign } from '@retail/campaign/types';
import { CampaignName } from './CampaignName';
import { CampaignPeriod } from './CampaignPeriod';
import { CampaignPurchasePeriod } from './CampaignPurchasePeriod';
import { CampaignDescription } from './CampaignDescription';
import { MetadataBox } from './MetadataBox';
import { CampaignMandatory } from './CampaignMandatory';
import { CampaignTypeView } from './CampaignTypeView';
import { MetadataHeader } from './MetadataHeader';

interface Props {
  campaign: MemberCampaign;
  onSaveCampaignName?: (campaignName: string) => void;
  onSaveCampaignPeriod?: (validFrom: Date, validTo: Date) => void;
  onSavePurchasePeriod?: (purchasePeriodFrom: Date, purchasePeriodTo: Date) => void;
  onSaveDescription?: (description: string) => void;
}

export const MemberCampaignMetadata = ({
  campaign,
  onSaveCampaignName,
  onSaveCampaignPeriod,
  onSavePurchasePeriod,
  onSaveDescription,
}: Props) => {
  return (
    <MetadataBox>
      {({ isOpen, onToggle }) => (
        <>
          <MetadataHeader isOpen={isOpen} onToggle={onToggle}>
            <CampaignName name={campaign.name} onSave={onSaveCampaignName} />
          </MetadataHeader>
          <Collapse in={isOpen}>
            <Grid container rowSpacing={0.5} columnSpacing={4} mx={1}>
              <Grid size={4}>
                <CampaignPeriod
                  validFrom={campaign.validFrom}
                  validTo={campaign.validTo}
                  onSave={onSaveCampaignPeriod}
                />
              </Grid>
              <Grid size={4}>
                <CampaignPurchasePeriod
                  from={campaign.purchasePeriodFrom}
                  to={campaign.purchasePeriodTo}
                  onSave={onSavePurchasePeriod}
                />
              </Grid>
              <Grid size={4}>
                <CampaignMandatory mandatory={campaign.mandatory} />
              </Grid>
              <Grid size={4}>
                <CampaignTypeView type={campaign.campaignType} />
              </Grid>
              <Grid size={8}>
                <CampaignDescription
                  description={campaign.description}
                  onSave={onSaveDescription}
                />
              </Grid>
            </Grid>
          </Collapse>
        </>
      )}
    </MetadataBox>
  );
};
